/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversationalAgentThreadResource
 */
export interface ConversationalAgentThreadResource {
    /**
     * Id of the created thread
     * @type {string}
     * @memberof ConversationalAgentThreadResource
     */
    threadId: string;
}

/**
 * Check if a given object implements the ConversationalAgentThreadResource interface.
 */
export function instanceOfConversationalAgentThreadResource(value: object): value is ConversationalAgentThreadResource {
    if (!('threadId' in value) || value['threadId'] === undefined) return false;
    return true;
}

export function ConversationalAgentThreadResourceFromJSON(json: any): ConversationalAgentThreadResource {
    return ConversationalAgentThreadResourceFromJSONTyped(json, false);
}

export function ConversationalAgentThreadResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationalAgentThreadResource {
    if (json == null) {
        return json;
    }
    return {
        
        'threadId': json['threadId'],
    };
}

export function ConversationalAgentThreadResourceToJSON(value?: ConversationalAgentThreadResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'threadId': value['threadId'],
    };
}

